/* @flow */
import flow from 'lodash/flow';
import entries from 'lodash/fp/entries';
import reduce from 'lodash/fp/reduce';

export default (url: string, variables: { [string]: string }): string =>
  flow([entries, reduce((acc, [k, v]) => acc.replace(`:${k}`, v), url)])(variables);
